const MartinLewisQuote = () => {
  return (
    <section className="w-full bg-gradient-to-r from-[#F9FAFB] to-white">
      <div className="w-full max-w-[1200px] mx-auto">
        <img
          src="/lovable-uploads/b64cfd23-4387-4436-a79d-4be5708a680c.png"
          alt="Martin Lewis Quote"
          className="w-full h-auto object-contain"
        />
      </div>
    </section>
  );
};

export default MartinLewisQuote;